import { render, staticRenderFns } from "./PanelResumenSemana.vue?vue&type=template&id=517a55b1&scoped=true"
import script from "./PanelResumenSemana.vue?vue&type=script&lang=js"
export * from "./PanelResumenSemana.vue?vue&type=script&lang=js"
import style0 from "./PanelResumenSemana.vue?vue&type=style&index=0&id=517a55b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517a55b1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VIcon,VRow})
